module.exports = __webpack_public_path__ + "img/1200-plain.7be1c31e.png";